export default __webpack_public_path__ + "static/media/smartphone.bd3009e2.svg";